module.exports = __webpack_public_path__ + "static/img/bg-es.1107c584.png";